import LinkButton, { LinkButtonProps } from '@/components/atoms/LinkButton';

import { BlockComponentModel } from '@/cms/types/blok-component';

import { transformFromCMSLink } from './utils';

export type LinkButtonStrapiSideSectionsProps = {
  leftSection?: string;
  rightSection?: string;
};

export type LinkButtonStrapiProps = LinkButtonStrapiSideSectionsProps & {
  text?: string;
  url: string;
  openInNewTab?: boolean;
  variant?: LinkButtonProps['variant'];
  color?: LinkButtonProps['color'];
  phTracker?: string;
};

export default function LinkButtonStrapi({
  block,
  inner,
}: BlockComponentModel<LinkButtonStrapiProps, LinkButtonProps>) {
  const props = transformFromCMSLink(block);

  return (
    <LinkButton {...(props as LinkButtonProps)} {...inner}>
      {block.text}
    </LinkButton>
  );
}
